// extracted by mini-css-extract-plugin
export default {"container":"Tile_container__C4s9A","main":"Tile_main__jJ2rd","title":"Tile_title__c9B-6","count":"Tile_count__K2mGy"};